export const environment = {
  production: false,
  serverUrl: 'https://lidoinfoapi.rrsolutionstest.it/api/v1/frontend/',
  imageUrl: 'https://picslidoinfo.rrsolutionstest.it/static_images/',
  dynamicImageUrl: 'https://picslidoinfo.rrsolutionstest.it/',
  vssImageUrl: 'https://picsvssinfo.rrsolutionstest.it/',
  useOldLidoFacilities: false
};
